import { Accordion } from '@design-system/accordion';
import { ImagePlusText } from '@design-system/image-plus-text';
import { PageBlock } from '@design-system/page-block';
import classnames from 'classnames';
import React, { FC } from 'react';

import { imagePlusTextBlockMapper } from '~/mappers/imagePlusTextBlock';

import { AccordionListProps } from './models';

const AccordionList: FC<AccordionListProps> = ({
  list,
  headlineTag,
  semanticVariant,
  pageBlock,
  viewVariant,
  variant,
  componentId,
}) => {
  const items = list.map(({ accordionTitle, content, disabled }) => ({
    title: accordionTitle,
    children: (
      <>
        {content.map((value) => (
          <ImagePlusText
            {...imagePlusTextBlockMapper({ ...value, image: value.image?.[0] })}
          />
        ))}
      </>
    ),
    disabled,
    tabIndex: 0,
  }));

  return (
    <PageBlock {...pageBlock} id={componentId} className="accordion">
      <Accordion
        items={items}
        headlineTag={headlineTag}
        semanticVariant={semanticVariant}
        expandVariant={variant}
        viewVariant={viewVariant}
        className={classnames('accordion-list')}
        closeIcon={{
          icon: 'hide',
        }}
        openIcon={{
          icon: 'add',
        }}
      />
    </PageBlock>
  );
};

export default AccordionList;
